export type HeaderWordmarkStatus = "idle" | "loading";

type HeaderWordmarkSnapshot = {
    status: HeaderWordmarkStatus;
};

export const HEADER_WORDMARK_LOADING_EXIT_MS = 250;
export const HEADER_WORDMARK_LOADING_DELAY_MS = 200;

const listeners = new Set<() => void>();
let snapshot: HeaderWordmarkSnapshot = { status: "idle" };
let emptyCheckQueued = false;
let loadingDelayTimer: ReturnType<typeof setTimeout> | null = null;

function publish(status: HeaderWordmarkStatus) {
    snapshot = { status };
    for (const listener of listeners) listener();
}

function reset() {
    if (loadingDelayTimer !== null) {
        clearTimeout(loadingDelayTimer);
        loadingDelayTimer = null;
    }
    if (snapshot.status !== "idle") publish("idle");
}

export function subscribeHeaderWordmark(listener: () => void) {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
        if (listeners.size > 0 || emptyCheckQueued) return;
        emptyCheckQueued = true;
        queueMicrotask(() => {
            emptyCheckQueued = false;
            if (listeners.size === 0) reset();
        });
    };
}

export function subscribeStaticHeaderWordmark() {
    return () => {};
}

export function getHeaderWordmarkSnapshot() {
    return snapshot;
}

const staticSnapshot: HeaderWordmarkSnapshot = {
    status: "idle",
};

export function getStaticHeaderWordmarkSnapshot() {
    return staticSnapshot;
}

function beginHeaderWordmarkLoading() {
    if (listeners.size === 0) return;
    if (snapshot.status === "loading") return;
    if (loadingDelayTimer !== null) clearTimeout(loadingDelayTimer);
    loadingDelayTimer = setTimeout(() => {
        loadingDelayTimer = null;
        if (listeners.size > 0) publish("loading");
    }, HEADER_WORDMARK_LOADING_DELAY_MS);
}

function finishHeaderWordmarkLoading() {
    if (loadingDelayTimer !== null) {
        clearTimeout(loadingDelayTimer);
        loadingDelayTimer = null;
    }
    if (snapshot.status === "loading") publish("idle");
}

export function finishHeaderWordmarkSearchOnPaint(node: Element | null) {
    if (node) finishHeaderWordmarkLoading();
}

export function withHeaderWordmarkSearchLoading<Result>(
    action: () => Result,
): Result {
    beginHeaderWordmarkLoading();
    return action();
}

export function resetHeaderWordmarkMotion() {
    reset();
}
